@use "sass:math";
@use "~theme/typographyV2" as typography;
@use "~theme/breakpoints";

$choices-width: 440px;

.container {
  flex-grow: 1; // ensures component stretches to fill the screen vertically
  width: 100%;
  margin-top: 32px;

  @include breakpoints.desktop {
    flex: 1;
  }
}

.layout {
  padding: 24px var(--mobile-gutter);
  display: grid;
  align-content: start;
  height: auto;
  opacity: 1;
  gap: 2px;
  border-radius: 20px;
  padding: 24px;
  background: var(--white);
  margin-bottom: 15px;
  margin: 10px;

  @include breakpoints.desktop {
    height: auto;
    gap: 2px;
    align-content: start;
    opacity: 1;
    border-radius: 20px;
    padding: 32px;
    margin: 20px;
    overflow: visible;
    background-color: var(--white);
    border-bottom: 1px solid var(--gray-06);
    position: relative;
    z-index: 0;
  }

  > * {
    @include breakpoints.desktop {
      max-width: 880px;
    }
  }
}

.divider {
  display: none;

  @include breakpoints.desktop {
    @include typography.heading3;
    display: block;
    margin: 0px;
    border: none;
    border-bottom: 1px solid var(--brand-indigo);
    width: 30em;
  }
}

.prompt {
  margin-bottom: 0;
  @include breakpoints.desktop {
    max-width: 100%;
    margin-bottom: 0;
  }
}

.headline {
  font-family: "Instrument Serif";
  font-weight: 400;
  font-style: normal;
  font-size: 32px;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
  color: var(--brand-indigo);
  letter-spacing: 0%;
  margin: 0;
}

.choices {
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 30px;

  @include breakpoints.desktop {    
    width: 413.86px;
    margin-top: 30px;
  }
}

.bg {
  @include breakpoints.desktop {
    grid-area: bg;
    background: no-repeat center/cover url("~images/woman.jpg");
    overflow: hidden;
    position: relative;
  }
}

// This pseudoelement is the triangular area that partially covers the bg image
.bg::after {
  @include breakpoints.desktop {
    $rotate-amount: 13deg;
    content: "";
    position: absolute;
    bottom: 0;
    right: 100%;
    width: 100%;

    // stretch the diagonal area so it has the right height.
    height: math.div(100%, math.sin(90deg - $rotate-amount));
    background-color: var(--gray-04);
    transform-origin: bottom right;
    transform: rotate($rotate-amount);
  }
}

.button {
  border: 4px solid var(--white);
  border-radius: 8px;
  cursor: pointer;
  box-shadow: 0px 4px 8px 0px rgb(0 0 0 / 10%);
  height: 65px;
  padding: 0 16px;
  background-color: var(--white);
  margin: 0;
  align-items: center;
  outline: none;
  width: 100%;
  text-align: center;
  font-size: 1rem;

  font-family: typography.$font-mont;
  font-weight: 600;
  font-style: normal;
  font-size: 14px;
  line-height: 120%;
  letter-spacing: 0px;
  vertical-align: middle;
  text-transform: uppercase;


  &:hover {
    border-color: var(--highlight-blue);
  }

  &:active {
    // filter: drop-shadow(0 2px 4px var(--highlight-blue));
    // border-color: var(--white);
    border-color: var(--highlight-blue);
  }

    // &:focus {
    //   filter: drop-shadow(0 2px 4px var(--highlight-blue));
    // }
}

.selected {
  border: 4px solid var(--highlight-blue);
  box-shadow: 0px 4px 8px 0px rgb(0 0 0 / 10%);
  @include breakpoints.desktop {
    background: var(--blue-03);
    border: 4px solid var(--highlight-blue);
  }
}

.requiredMessage {
  font-family: typography.$font-mont;
  font-style: normal;
  color: red;
  padding-top: 12px;
  padding-bottom: 0;
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  @include breakpoints.desktop {
    font-weight: 600;
    font-size: 16px;
    line-height: 22.4px;
    letter-spacing: 0.32px;
    vertical-align: middle;
  }
}
